// extracted by mini-css-extract-plugin
export var sliderRange = "_pg-2";
export var sliderRoot = "_pg-0";
export var sliderThumb = "_pg-3";
export var sliderTrack = "_pg-1";